export class AgeRange {
    ageRangeID: number;
    name: string;
    fromAge: number;
    toAge: number;
    buildIn: boolean;
}